module.exports = __webpack_public_path__ + "img/SK00682420.ac5a6d8f.png";